import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EarlyInterventionSystemList from './List';
import Details from './Details';

export default function EarlyInterventionSystem() {
  return (
    <Routes>
      <Route
        index
        element={<EarlyInterventionSystemList />}
      />
      <Route
        path='details/:id/*'
        element={<Details />}
      />
      <Route
        path='*'
        element={
          <Navigate
            to='/admin/performance-reporting/early-intervention-system'
            replace
          />
        }
      />
    </Routes>
  );
}

